import { create } from "zustand";

const initialState = {
  searchQuery: "",
  sortBy: "created_at",
  sortOrder: "desc",
  filterType: "",
  page: 1,
  selectedFileId: null,
  viewModalOpen: false,
  viewerFile: null,
  shareModalOpen: false,
  shareFileData: null,
  uploadQueue: [],
  isUploading: false,
  deleteModalOpen: false,
  deletingFile: null,
  currentFolderId: null,
  createFolderOpen: false,
  renameItem: null,
  moveItem: null,
  deleteFolder: null,
};

export const useFileManagerStore = create((set) => ({
  ...initialState,

  setSearchQuery: (query) => set({ searchQuery: query || "", page: 1 }),

  setSortBy: (field) =>
    set((state) => ({
      sortBy: field,
      sortOrder:
        state.sortBy === field
          ? state.sortOrder === "asc"
            ? "desc"
            : "asc"
          : "desc",
    })),

  setSort: (field, order) => set({ sortBy: field, sortOrder: order }),

  setFilterType: (type) => set({ filterType: type || "", page: 1 }),

  setPage: (page) => set({ page }),

  setSelectedFileId: (id) => set({ selectedFileId: id }),

  openViewer: (file) => set({ viewModalOpen: true, viewerFile: file }),

  closeViewer: () => set({ viewModalOpen: false, viewerFile: null }),

  openShareModal: (file) =>
    set({ shareModalOpen: true, shareFileData: file }),

  closeShareModal: () =>
    set({ shareModalOpen: false, shareFileData: null }),

  openDeleteModal: (file) =>
    set({ deleteModalOpen: true, deletingFile: file }),

  closeDeleteModal: () =>
    set({ deleteModalOpen: false, deletingFile: null }),

  setCurrentFolderId: (id) => set({ currentFolderId: id, page: 1 }),

  openCreateFolder: () => set({ createFolderOpen: true }),
  closeCreateFolder: () => set({ createFolderOpen: false }),

  openRename: (item) => set({ renameItem: item }),
  closeRename: () => set({ renameItem: null }),

  openMove: (item) => set({ moveItem: item ? { ...item } : null }),
  closeMove: () => set({ moveItem: null }),

  openDeleteFolder: (folder) => set({ deleteFolder: folder }),
  closeDeleteFolder: () => set({ deleteFolder: null }),

  enqueueFiles: (files) =>
    set((state) => ({
      uploadQueue: [
        ...state.uploadQueue,
        ...files.map((f) => ({
          file: f,
          name: f.name,
          size: f.size,
          type: f.type,
          id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
          progress: 0,
          speed: 0,
          eta: null,
          status: "pending",
          error: null,
          startedAt: null,
          loaded: 0,
        })),
      ],
    })),

  updateUpload: (id, updates) =>
    set((state) => ({
      uploadQueue: state.uploadQueue.map((item) =>
        item.id === id ? { ...item, ...updates } : item
      ),
    })),

  removeUpload: (id) =>
    set((state) => ({
      uploadQueue: state.uploadQueue.filter((item) => item.id !== id),
      isUploading: state.uploadQueue.filter((item) => item.id !== id).some(
        (item) => item.status === "uploading" || item.status === "pending"
      ),
    })),

  setIsUploading: (val) => set({ isUploading: val }),

  clearCompletedUploads: () =>
    set((state) => ({
      uploadQueue: state.uploadQueue.filter(
        (item) => item.status !== "success"
      ),
    })),

  reset: () => set(initialState),
}));
